import React from "react";
const OfferBar = () => {
	const enableOffer = false;
	const offerCode = 'norooz1401';
	const onCopy = () => {
		navigator.clipboard.writeText(offerCode)
		alert('کد تخفیف کپی شد.')
	}
	if(!enableOffer) return "";
	return(
		<div className='offer-wrap'>
			<strong>30% تخفیف</strong>
			<p>فقط تا پایان تعطیلات</p>
			<em>{offerCode}</em>
			<button onClick={onCopy}>کپی کن</button>
		</div>
	)
}

export default OfferBar;